import React from 'react'
import '../../styles/Diagnostic/DiagnosticPlomb.css'
import { Fade } from 'react-awesome-reveal'
import diagnosticPlombSection1 from '../../assets/diagnostic/diagnostic-plomb-section1.jpg'
import { Accordion, Col, Row } from 'react-bootstrap'
import diagnosticPlombSection2 from '../../assets/diagnostic/diagnostic-plomb-section2.jpg'
import diagnosticPlombSection3 from '../../assets/diagnostic/diagnostic-plomb-section3.jpg'
import AccordionText from '../Utils/AccordionText'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function DiagnosticPlomb() {

    const section5AccordionData = [
        {
            title: "Est-ce que le diagnostic plomb est obligatoire pour tous les biens immobiliers ?",
            text: "Nous tenons à informer nos clients que le diagnostic plomb est obligatoire pour tous les biens construits avant 1949, lors de la vente ou la location. Ce diagnostic vise à protéger les occupants contre les risques d’exposition au plomb."
        }, {
            title: "Quelle est la durée de validité d'un diagnostic plomb ?",
            text: "La durée de validité du diagnostic plomb dépend de ses résultats. Si le diagnostic ne révèle pas la présence de plomb, le certificat de conformité est valable indéfiniment pour les propriétaires. Toutefois, en cas de présence détectée de " +
                "plomb, la validité dans le cadre d’une vente est de un an et dans le cadre d’une location la validité est portée à six ans. E5M Diagnostics vous guide à travers ces nuances pour assurer que votre bien reste conforme aux réglementations en vigueur."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Diagnostic Plomb - E5M Diagnostics" />
                <meta name="description" content="Diagnostic Plomb sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Diagnostic Plomb - E5M Diagnostics" />
                <meta property="og:description" content="Diagnostic Plomb sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/diagnostic-plomb" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/diagnostic-plomb" />
            </Helmet>

            <BrowserView>
                <div id='diagnosticPlomb'>
                    <div id='header'>
                        <div id='diagnosticPlombHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <div id='headerFilterTitle'>Diagnostic Plomb</div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='diagnosticPlombSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticPlombSection1Left'>
                                    <h1 className='sectionTitle'>L'importance du diagnostic plomb</h1>
                                    <div className='sectionText'>
                                        E5M Diagnostics, nous sommes conscients de l’importance cruciale du diagnostic plomb pour garantir non seulement la santé et la sécurité des occupants. Notre rôle est de vous fournir une information précise et de naviguer à travers les
                                        procédures nécessaires pour évaluer sa présence dans votre propriété et, en fonction des résultats, un rapport précis vous sera délivré afin d’identifier les unités de diagnostics positives et de veiller à leurs non détérioration ou a leurs suppression.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticPlombSection1Right'>
                                    <img src={diagnosticPlombSection1} id='diagnosticPlombSection1Image' alt='diagnostic-plomb-section1' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticPlombSection2'>
                        <Col sm={6}>
                            <div id='diagnosticPlombSection2Left'>
                                <Fade direction={'right'} duration={500}>
                                    <img src={diagnosticPlombSection2} id='diagnosticPlombSection2Image' alt='diagnostic-plomb-section2' />
                                </Fade>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='diagnosticPlombSection2Right'>
                                    <h1 className='sectionTitle'>Qu'est-ce que le plomb et où peut-il être trouvé ?</h1>
                                    <div className='sectionText'>
                                        Le plomb est un métal lourd toxique qui, avant que ses dangers ne soient pleinement reconnus, a été largement utilisé dans les peintures. Notre expertise nous permet d’identifier les zones à risque où il peut encore être
                                        présent, notamment dans les bâtiments anciens. Sa présence représente un risque significatif pour la santé, et c’est pourquoi nous nous engageons à effectuer des diagnostics précis pour déterminer la présence ou non de plombs
                                        dans les peintures de votre logement.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='diagnosticPlombSection3'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticPlombSection3Left'>
                                    <h1 className='sectionTitle'>Pourquoi réaliser un diagnostic plomb ?</h1>
                                    <div className='sectionText'>
                                        La réalisation d’un diagnostic est indispensable pour assurer la sécurité des occupants et répondre aux exigences réglementaires. Nous soulignons que ce diagnostic est crucial pour détecter sa présence dans les peintures
                                        et ainsi en informer les acquéreurs ou locataires.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='diagnosticPlombSection3Right'>
                                    <img src={diagnosticPlombSection3} id='diagnosticPlombSection3Image' alt='diagnostic-plomb-section3' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticPlombSection4'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Comment se déroule un diagnostic plomb ?</h1>
                            <div className='sectionText'>
                                Le processus de diagnostic plomb avec E5M Diagnostics commence par une évaluation minutieuse de votre bien immobilier. Nous utilisons des techniques avancées pour détecter avec précision sa présence. Il vous sera
                                transmit un rapport exhaustif mentionnant la présence ou non de plomb dans les peintures dans un tableau explicatif et sur le croquis de repérage de votre appartement.
                            </div>
                        </Fade>
                    </div>
                    <Row id='diagnosticPlombSection5'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticPlombSection5Left'>
                                    <h1 className='sectionTitle'>FAQ - Questions fréquemment posées</h1>
                                    <div id='diagnosticPlombSection5Accordion' className='sectionAccordionDark'>
                                        <Accordion>
                                            {section5AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='diagnosticPlombSection5Right'>
                                    <h1 className='sectionTitle'>Que faire si sa présence est confirmée ?</h1>
                                    <div className='sectionText'>
                                        Lorsque la présence est avérée dans votre logement, il n’est pas obligatoire de procéder à son retrait, il faut simplement être vigilent sur son état de dégradation et en tenir compte dans les travaux futur afin de ne pas s’exposé aux poussières.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='diagnosticPlombSection6'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitle'>Partenaire de confiance</h1>
                            <div className='sectionText'>
                                La mission d’E5M Diagnostics est de garantir la sécurité des biens immobiliers par rapport au plomb, en fournissant des diagnostics précis et en accompagnant nos clients dans l’obtention de certificats de conformité. Notre engagement
                                envers la santé publique et la conformité réglementaire nous pousse à offrir des conseils experts et des solutions pratiques pour traiter la présence de plomb. Que vous soyez propriétaire, acheteur ou locataire, nous sommes là pour
                                assurer que votre environnement est sécurisé et conforme, reflétant notre dévouement à la protection de votre bien-être et à la préservation de la valeur de votre propriété. Chez E5M Diagnostics, nous sommes votre partenaire de confiance
                                pour naviguer dans les complexités du diagnostic plomb et pour sécuriser votre espace de vie contre les risques d’exposition.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='diagnosticPlomb'>
                    <div id='header'>
                        <div id='diagnosticPlombHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Diagnostic Plomb</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='diagnosticPlombSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>L'importance du diagnostic plomb</h1>
                            <div className='sectionTextMobile'>
                                E5M Diagnostics, nous sommes conscients de l’importance cruciale du diagnostic plomb pour garantir non seulement la santé et la sécurité des occupants. Notre rôle est de vous fournir une information précise et de naviguer à travers les
                                procédures nécessaires pour évaluer sa présence dans votre propriété et, en fonction des résultats, un rapport précis vous sera délivré afin d’identifier les unités de diagnostics positives et de veiller à leurs non détérioration ou a leurs suppression.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticPlombSection1} id='diagnosticPlombSection1ImageMobile' alt='diagnostic-plomb-section1' />
                        </Fade>
                    </div>
                    <div id='diagnosticPlombSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <img src={diagnosticPlombSection2} id='diagnosticPlombSection2ImageMobile' alt='diagnostic-plomb-section2' />
                        </Fade>
                        <Fade direction={'right'} duration={500} delay={100}>
                            <h1 className='sectionTitleMobile'>Qu'est-ce que le plomb et où peut-il être trouvé ?</h1>
                            <div className='sectionTextMobile'>
                                Le plomb est un métal lourd toxique qui, avant que ses dangers ne soient pleinement reconnus, a été largement utilisé dans les peintures. Notre expertise nous permet d’identifier les zones à risque où il peut encore être
                                présent, notamment dans les bâtiments anciens. Sa présence représente un risque significatif pour la santé, et c’est pourquoi nous nous engageons à effectuer des diagnostics précis pour déterminer la présence ou non de plombs
                                dans les peintures de votre logement.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticPlombSection3Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Pourquoi réaliser un diagnostic plomb ?</h1>
                            <div className='sectionTextMobile'>
                                La réalisation d’un diagnostic est indispensable pour assurer la sécurité des occupants et répondre aux exigences réglementaires. Nous soulignons que ce diagnostic est crucial pour détecter sa présence dans les peintures
                                et ainsi en informer les acquéreurs ou locataires.
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500} delay={100}>
                            <img src={diagnosticPlombSection3} id='diagnosticPlombSection3ImageMobile' alt='diagnostic-plomb-section3' />
                        </Fade>
                    </div>
                    <div id='diagnosticPlombSection4Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Comment se déroule un diagnostic plomb ?</h1>
                            <div className='sectionTextMobile'>
                                Le processus de diagnostic plomb avec E5M Diagnostics commence par une évaluation minutieuse de votre bien immobilier. Nous utilisons des techniques avancées pour détecter avec précision sa présence. Il vous sera
                                transmit un rapport exhaustif mentionnant la présence ou non de plomb dans les peintures dans un tableau explicatif et sur le croquis de repérage de votre appartement.
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticPlombSection5Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>FAQ - Questions fréquemment posées</h1>
                            <div className='sectionAccordionDark sectionAccordionDarkMobile'>
                                <Accordion>
                                    {section5AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                        <Fade direction={'left'} duration={500}>
                            <div id='diagnosticPlombSection5RightMobile'>
                                <h1 className='sectionTitleMobile'>Que faire si sa présence est confirmée ?</h1>
                                <div className='sectionTextMobile'>
                                    Lorsque la présence est avérée dans votre logement, il n’est pas obligatoire de procéder à son retrait, il faut simplement être vigilent sur son état de dégradation et en tenir compte dans les travaux futur afin de ne pas s’exposé aux poussières.
                                </div>
                            </div>
                        </Fade>
                    </div>
                    <div id='diagnosticPlombSection6Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Partenaire de confiance</h1>
                            <div className='sectionTextMobile'>
                                La mission d’E5M Diagnostics est de garantir la sécurité des biens immobiliers par rapport au plomb, en fournissant des diagnostics précis et en accompagnant nos clients dans l’obtention de certificats de conformité. Notre engagement
                                envers la santé publique et la conformité réglementaire nous pousse à offrir des conseils experts et des solutions pratiques pour traiter la présence de plomb. Que vous soyez propriétaire, acheteur ou locataire, nous sommes là pour
                                assurer que votre environnement est sécurisé et conforme, reflétant notre dévouement à la protection de votre bien-être et à la préservation de la valeur de votre propriété. Chez E5M Diagnostics, nous sommes votre partenaire de confiance
                                pour naviguer dans les complexités du diagnostic plomb et pour sécuriser votre espace de vie contre les risques d’exposition.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default DiagnosticPlomb